import { useQuery } from '@tanstack/react-query';
import { apiGet } from '../api';

export interface TenantRow {
  id: string;
  kind: string;
  name: string;
  city: string;
  points: number;
}

/** Единый ключ справочника городов: и оболочка (App.tsx), и редактор берут один и тот же кэш —
 * запрос уходит один раз. Смену сессии обслуживает qc.clear() в acceptSession/logout. */
export const TENANTS_KEY = ['tenants'] as const;

export function fetchTenants(signal?: AbortSignal) {
  return apiGet<{ tenants: TenantRow[] }>('/api/tenants', signal);
}

/** Число точек по городу (GET /api/tenants). Пока грузится — пустой объект. */
export function useTenantPoints(enabled = true): Record<string, number> {
  const query = useQuery({
    queryKey: TENANTS_KEY,
    queryFn: ({ signal }) => fetchTenants(signal),
    staleTime: 300_000,
    enabled,
    select: (data) =>
      Object.fromEntries(
        (data.tenants ?? [])
          .filter((item) => typeof item.points === 'number')
          .map((item) => [item.id, item.points as number]),
      ) as Record<string, number>,
  });
  return query.data ?? {};
}
